import { render, staticRenderFns } from "./FamilyCaregiverDetail.vue?vue&type=template&id=f1497c60&scoped=true&"
import script from "./FamilyCaregiverDetail.vue?vue&type=script&lang=js&"
export * from "./FamilyCaregiverDetail.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCaregiverDetail.vue?vue&type=style&index=0&id=f1497c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1497c60",
  null
  
)

export default component.exports